import ColorLens from '@mui/icons-material/ColorLens'
import { Drawer, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import { useToggle } from '@workwave-tidal/core/hooks'
import { Content } from './components/Content.js'

const toolName = 'Color lookup util'

export function ColorLookup({ sidebarOpen }: { sidebarOpen?: boolean }) {
  const [open, , onOpen, onClose] = useToggle()

  return (
    <>
      <Tooltip arrow placement="right" title={sidebarOpen ? '' : toolName}>
        <ListItem
          data-testid="color-lookup-toggler"
          disablePadding
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-end',
            p: 0,
          }}
        >
          <ListItemButton
            onClick={onOpen}
            selected={open}
            sx={{
              justifyContent: sidebarOpen ? 'initial' : 'center',
              minHeight: 48,
              p: 0,
            }}
          >
            <ListItemIcon
              sx={{
                justifyContent: 'center',
                minWidth: 0,
                px: 1,
              }}
            >
              <ColorLens />
            </ListItemIcon>
            <ListItemText primary={toolName} sx={{ opacity: sidebarOpen ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
      </Tooltip>

      <Drawer onClose={onClose} open={open}>
        <Content />
      </Drawer>
    </>
  )
}
